/**
 * Created by xingxiaowen on 2018/08/31
 * @type {string}
 */

// api 服务host
export const host = ''
// websocket端点
export const wsUrl = '/rts/point'

// cms服务context
export const cmsServerContext = '/cms'

// 授权服务context
export const oauthServerContext = '/oauthServer'

// 业主用户角色id
export const tenantId = '0fd4eb90fb714955b49564b3ba3de7de'

// 能源分项电的id
export const electricityId = '480d65f3-a47e-427c-b649-b3d179b3c0e2'

// 能源分项水的id
export const waterId = '16396ef1-06a1-4896-a3d6-6c3eb17df360'

// 仪表能源类型电的id
export const waterMeterTypeId = '480d65f3-a47e-427c-b649-b3d179b3c0e2'

// 建筑区域id
export const approachId = '9bb6aac8e2a440e28d04230d87ad15fe'

// 运行监测页面刷新时间
export const refreshTime = 5000

// 余额不足报警
export const balance = '08228ea7-1575-4b95-9a0d-592edfff4f19'

export const non_electric_meter_ids = ["2d49e0b5-f37d-11e8-9c8f-0235d2b38928","69e51132-fefb-5b60-b5a8-9164176467d8"]
